export default {"src":"/_next/static/media/save-money.colour.14f31fd5.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};